import { render, staticRenderFns } from "./StokEkstreSatislar.vue?vue&type=template&id=d6b27c4a&"
import script from "./StokEkstreSatislar.vue?vue&type=script&lang=js&"
export * from "./StokEkstreSatislar.vue?vue&type=script&lang=js&"
import style0 from "./StokEkstreSatislar.vue?vue&type=style&index=0&id=d6b27c4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports